import { HttpHeaders } from '@angular/common/http';

export const AppConstants = {
  httpOptions: {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  },
  httpOptionsPdf: {
    headers: new HttpHeaders({
      Accept: 'application/pdf',
      'Content-Type': 'application/json',
    }),
    responseType: 'blob',
  },
  storeNavigationInfo: true,
  pageSize: 30,
   datetimeParseFormat: 'dd/MM/yyyy HH:mm:ss',
  dateParseFormat: 'yyyy-MM-dd',
  datetimeFormat: 'dd/MM/yyyy HH:mm:ss',
  dateFormat: 'dd/MM/yyyy',
  titleErrorMessage: 'Errore',
  titleSuccessMessage: 'Salvataggio',
  titleDeleteSuccessMessage: 'Eliminazione',
  successMessage: 'Operazione effettuata con successo.',
  errorMessage: "Errore durante l'esecuzione dell'operazione.",
};
